import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    corporationSelected: JSON.parse(localStorage.corporation || null),
    corporationList: JSON.parse(localStorage.corporations || '[]')
  },
  mutations: {
    setCorporationSelected(state, corporation) {
      localStorage.corporation = JSON.stringify(corporation);
      state.corporationSelected = corporation;
    },
    addCorporation(state, corporation) {
      state.corporationList.push(corporation);
      localStorage.corporations = JSON.stringify(state.corporationList);
    },
    removeCorporation(state, corporationId) {
      for (let i = 0; i < state.corporationList.length; i++) {
        const itm = state.corporationList[i];
        if (itm.id == corporationId) {
          state.corporationList.splice(i, 1);
          localStorage.corporations = JSON.stringify(state.corporationList);
          break;
        }
      }
    },
    setCorporationList(state, corporationList) {
      localStorage.corporations = JSON.stringify(corporationList);
      state.corporationList = corporationList;
    },
  },
  actions: {
    setCorporationSelected(context, corporation) {
      context.commit('setCorporationSelected', corporation)
    },
    addCorporation(context, corporation) {
      context.commit('addCorporation', corporation)
    },
    removeCorporation(context, corporationId) {
      context.commit('removeCorporation', corporationId)
    },
    setCorporationList(context, corporationList) {
      context.commit('setCorporationList', corporationList)
    }
  },
  getters: {
    corporationSelected: state => state.corporationSelected,
    corporationList: state => state.corporationList
  }
})